module.exports = __webpack_public_path__ + "static/media/video_1.8780f1b7.mp4";